__turbopack_context__.v({
  "actions": "landing-module__qZN4Ta__actions",
  "activePage": "landing-module__qZN4Ta__activePage",
  "activePageDot": "landing-module__qZN4Ta__activePageDot",
  "amberText": "landing-module__qZN4Ta__amberText",
  "appBrand": "landing-module__qZN4Ta__appBrand",
  "appContent": "landing-module__qZN4Ta__appContent",
  "appHeading": "landing-module__qZN4Ta__appHeading",
  "appMain": "landing-module__qZN4Ta__appMain",
  "appMetrics": "landing-module__qZN4Ta__appMetrics",
  "appNote": "landing-module__qZN4Ta__appNote",
  "appPeriod": "landing-module__qZN4Ta__appPeriod",
  "appSearch": "landing-module__qZN4Ta__appSearch",
  "appSidebar": "landing-module__qZN4Ta__appSidebar",
  "appTableHeading": "landing-module__qZN4Ta__appTableHeading",
  "appTopbar": "landing-module__qZN4Ta__appTopbar",
  "betaNote": "landing-module__qZN4Ta__betaNote",
  "brand": "landing-module__qZN4Ta__brand",
  "builderDemo": "landing-module__qZN4Ta__builderDemo",
  "builderDemoLabel": "landing-module__qZN4Ta__builderDemoLabel",
  "builderDemoNote": "landing-module__qZN4Ta__builderDemoNote",
  "builderDetails": "landing-module__qZN4Ta__builderDetails",
  "builderFooter": "landing-module__qZN4Ta__builderFooter",
  "builderPicker": "landing-module__qZN4Ta__builderPicker",
  "builderResult": "landing-module__qZN4Ta__builderResult",
  "builderSection": "landing-module__qZN4Ta__builderSection",
  "builderTable": "landing-module__qZN4Ta__builderTable",
  "builderToolbar": "landing-module__qZN4Ta__builderToolbar",
  "captionDot": "landing-module__qZN4Ta__captionDot",
  "cellDelta": "landing-module__qZN4Ta__cellDelta",
  "checkList": "landing-module__qZN4Ta__checkList",
  "columnChip": "landing-module__qZN4Ta__columnChip",
  "columnGroup": "landing-module__qZN4Ta__columnGroup",
  "compositionItem": "landing-module__qZN4Ta__compositionItem",
  "compositionMenu": "landing-module__qZN4Ta__compositionMenu",
  "compositionMenuTitle": "landing-module__qZN4Ta__compositionMenuTitle",
  "connectedBadge": "landing-module__qZN4Ta__connectedBadge",
  "connectedTable": "landing-module__qZN4Ta__connectedTable",
  "container": "landing-module__qZN4Ta__container",
  "copyright": "landing-module__qZN4Ta__copyright",
  "ctaDemoButton": "landing-module__qZN4Ta__ctaDemoButton",
  "ctaFrog": "landing-module__qZN4Ta__ctaFrog",
  "dataSection": "landing-module__qZN4Ta__dataSection",
  "demoAction": "landing-module__qZN4Ta__demoAction",
  "demoBadge": "landing-module__qZN4Ta__demoBadge",
  "demoError": "landing-module__qZN4Ta__demoError",
  "desktopNav": "landing-module__qZN4Ta__desktopNav",
  "documentColumns": "landing-module__qZN4Ta__documentColumns",
  "documentCrumb": "landing-module__qZN4Ta__documentCrumb",
  "documentDescription": "landing-module__qZN4Ta__documentDescription",
  "documentNote": "landing-module__qZN4Ta__documentNote",
  "documentPreview": "landing-module__qZN4Ta__documentPreview",
  "documentTable": "landing-module__qZN4Ta__documentTable",
  "documentTitle": "landing-module__qZN4Ta__documentTitle",
  "emptyCheck": "landing-module__qZN4Ta__emptyCheck",
  "externalCaption": "landing-module__qZN4Ta__externalCaption",
  "externalCell": "landing-module__qZN4Ta__externalCell",
  "externalDemo": "landing-module__qZN4Ta__externalDemo",
  "externalHead": "landing-module__qZN4Ta__externalHead",
  "faqLayout": "landing-module__qZN4Ta__faqLayout",
  "faqList": "landing-module__qZN4Ta__faqList",
  "finalCta": "landing-module__qZN4Ta__finalCta",
  "footer": "landing-module__qZN4Ta__footer",
  "footerNote": "landing-module__qZN4Ta__footerNote",
  "header": "landing-module__qZN4Ta__header",
  "headerActions": "landing-module__qZN4Ta__headerActions",
  "headerCta": "landing-module__qZN4Ta__headerCta",
  "headerInner": "landing-module__qZN4Ta__headerInner",
  "heatActive": "landing-module__qZN4Ta__heatActive",
  "heatIcon": "landing-module__qZN4Ta__heatIcon",
  "hero": "landing-module__qZN4Ta__hero",
  "heroBenefits": "landing-module__qZN4Ta__heroBenefits",
  "heroCopy": "landing-module__qZN4Ta__heroCopy",
  "heroHint": "landing-module__qZN4Ta__heroHint",
  "heroIntro": "landing-module__qZN4Ta__heroIntro",
  "heroPreview": "landing-module__qZN4Ta__heroPreview",
  "heroTag": "landing-module__qZN4Ta__heroTag",
  "inlineLink": "landing-module__qZN4Ta__inlineLink",
  "insightIcon": "landing-module__qZN4Ta__insightIcon",
  "largeProductImage": "landing-module__qZN4Ta__largeProductImage",
  "lightButton": "landing-module__qZN4Ta__lightButton",
  "loginLink": "landing-module__qZN4Ta__loginLink",
  "menuToggle": "landing-module__qZN4Ta__menuToggle",
  "metricDescription": "landing-module__qZN4Ta__metricDescription",
  "miniChart": "landing-module__qZN4Ta__miniChart",
  "mobileNav": "landing-module__qZN4Ta__mobileNav",
  "modelProduct": "landing-module__qZN4Ta__modelProduct",
  "modelRow": "landing-module__qZN4Ta__modelRow",
  "pageBenefits": "landing-module__qZN4Ta__pageBenefits",
  "pageComposition": "landing-module__qZN4Ta__pageComposition",
  "pagesSection": "landing-module__qZN4Ta__pagesSection",
  "previewCaption": "landing-module__qZN4Ta__previewCaption",
  "primaryButton": "landing-module__qZN4Ta__primaryButton",
  "productCell": "landing-module__qZN4Ta__productCell",
  "productImage": "landing-module__qZN4Ta__productImage",
  "productTable": "landing-module__qZN4Ta__productTable",
  "reportArt": "landing-module__qZN4Ta__reportArt",
  "root": "landing-module__qZN4Ta__root",
  "section": "landing-module__qZN4Ta__section",
  "sectionHeading": "landing-module__qZN4Ta__sectionHeading",
  "sectionLabel": "landing-module__qZN4Ta__sectionLabel",
  "securityStrip": "landing-module__qZN4Ta__securityStrip",
  "selectedColumn": "landing-module__qZN4Ta__selectedColumn",
  "selectedColumns": "landing-module__qZN4Ta__selectedColumns",
  "sheetIcon": "landing-module__qZN4Ta__sheetIcon",
  "sidebarBottom": "landing-module__qZN4Ta__sidebarBottom",
  "sidebarLabel": "landing-module__qZN4Ta__sidebarLabel",
  "sidebarNew": "landing-module__qZN4Ta__sidebarNew",
  "sizeDemo": "landing-module__qZN4Ta__sizeDemo",
  "sizeDemoHint": "landing-module__qZN4Ta__sizeDemoHint",
  "sizeDemoTop": "landing-module__qZN4Ta__sizeDemoTop",
  "sizeInsight": "landing-module__qZN4Ta__sizeInsight",
  "sizeRows": "landing-module__qZN4Ta__sizeRows",
  "sizeTableHeader": "landing-module__qZN4Ta__sizeTableHeader",
  "sizeWarning": "landing-module__qZN4Ta__sizeWarning",
  "sizesCallout": "landing-module__qZN4Ta__sizesCallout",
  "sizesSection": "landing-module__qZN4Ta__sizesSection",
  "skipLink": "landing-module__qZN4Ta__skipLink",
  "sourceConnector": "landing-module__qZN4Ta__sourceConnector",
  "sourceSheet": "landing-module__qZN4Ta__sourceSheet",
  "sourceTabs": "landing-module__qZN4Ta__sourceTabs",
  "sourceTitle": "landing-module__qZN4Ta__sourceTitle",
  "sparkBars": "landing-module__qZN4Ta__sparkBars",
  "spin": "landing-module__qZN4Ta__spin",
  "spinner": "landing-module__qZN4Ta__spinner",
  "splitCopy": "landing-module__qZN4Ta__splitCopy",
  "splitSection": "landing-module__qZN4Ta__splitSection",
  "srOnly": "landing-module__qZN4Ta__srOnly",
  "startLayout": "landing-module__qZN4Ta__startLayout",
  "startSection": "landing-module__qZN4Ta__startSection",
  "steps": "landing-module__qZN4Ta__steps",
  "stockAlert": "landing-module__qZN4Ta__stockAlert",
  "supplyArt": "landing-module__qZN4Ta__supplyArt",
  "tableScroll": "landing-module__qZN4Ta__tableScroll",
  "templateArt": "landing-module__qZN4Ta__templateArt",
  "templateBars": "landing-module__qZN4Ta__templateBars",
  "templateCard": "landing-module__qZN4Ta__templateCard",
  "templateDescription": "landing-module__qZN4Ta__templateDescription",
  "templateGrid": "landing-module__qZN4Ta__templateGrid",
  "templateLines": "landing-module__qZN4Ta__templateLines",
  "templateMiniStats": "landing-module__qZN4Ta__templateMiniStats",
  "templatePaper": "landing-module__qZN4Ta__templatePaper",
  "templatesHint": "landing-module__qZN4Ta__templatesHint",
  "textButton": "landing-module__qZN4Ta__textButton",
  "toolIcon": "landing-module__qZN4Ta__toolIcon",
  "toolsGrid": "landing-module__qZN4Ta__toolsGrid",
  "toolsSection": "landing-module__qZN4Ta__toolsSection",
  "workspaceDemo": "landing-module__qZN4Ta__workspaceDemo",
});
